export default __webpack_public_path__ + "static/media/watch-image.3f2d1102.png";